import React from "react";
import NumberFormat from "react-number-format";

const TextInputMoneyFormik = ({ formik, field, format, disable, prefix, onChange, evento }) => (
  <>
    <NumberFormat
      id={field}
      name={field}
      format={format}
      thousandSeparator="."
      decimalSeparator=","
      prefix={prefix || "R$ "} // "R$ "
      decimalScale="2"
      fixedDecimalScale
      allowNegative={false}
      allowLeadingZeros={false}
      disabled={formik.isSubmitting || disable}
      value={formik.values[field]}
      onChange={onChange}
      onBlur={evento}
      isInvalid={formik.touched[field] && formik.errors[field]}
      className="form-control"
    />
    {formik.touched[field] && formik.errors[field] && <div className="invalid-feedback">{formik.errors[field]}</div>}
  </>
);

export default TextInputMoneyFormik;
